const phoneNumberRegEx = new RegExp('^[()+\\-\\s\\d]+$');

export const isValidPhoneNumber = (value: string | null | undefined): boolean =>
  typeof value === 'string' && !!phoneNumberRegEx.exec(value);
